module.exports = __webpack_public_path__ + "img/south_platte_drainage.2159e0a0.jpg";